import { render } from "./DashboardFleetInfo.vue?vue&type=template&id=2dbccae1"
import script from "./DashboardFleetInfo.vue?vue&type=script&lang=js"
export * from "./DashboardFleetInfo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__